var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSozialselbstbewusstWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.33 93.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#010101;}.cls-4{fill:#f3d4e6;}.cls-5{fill:#fff;}.cls-6,.cls-2,.cls-7,.cls-8,.cls-9,.cls-3{stroke-width:2px;}.cls-6,.cls-9{fill:none;}.cls-6,.cls-3{stroke:#020202;}.cls-2,.cls-7,.cls-8,.cls-9{stroke:#010101;stroke-miterlimit:10;}.cls-7{fill:#f15e5e;}.cls-8{fill:#eeeb67;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 19.63,
    y: 0.2,
    width: 125.56,
    height: 92.91,
    transform: "translate(.15 -.26) rotate(.18)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.68,
    y: 29.52,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.68,
    y: 30.52,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 20.68,
    y: 24.52,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 21.68,
    y: 25.52,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 60.01,
    cy: 25.15,
    r: 10.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.22,
    cy: 49.91,
    r: 10.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 56.29,
    cy: 73.09,
    r: 10.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 40.82,
    y1: 40.99,
    x2: 52.17,
    y2: 32.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 41.94,
    y1: 58.02,
    x2: 49.48,
    y2: 65.06
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.75,44.52l5.36-2.82c.97-.51,2.1,.31,1.92,1.39l-1.02,5.97c-.07,.43,.07,.87,.38,1.17l4.34,4.23c.78,.76,.35,2.1-.73,2.26l-6,.87c-.43,.06-.8,.33-1,.72l-2.68,5.43c-.48,.98-1.89,.98-2.37,0l-2.68-5.43c-.19-.39-.56-.66-1-.72l-6-.87c-1.08-.16-1.52-1.49-.73-2.26l4.34-4.23c.31-.3,.45-.74,.38-1.17l-1.02-5.97c-.19-1.08,.95-1.9,1.92-1.39l5.36,2.82c.39,.2,.85,.2,1.23,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.23,31.53l3.41-5.01c.62-.91,2-.71,2.35,.33l1.91,5.75c.14,.41,.47,.73,.89,.85l5.82,1.69c1.05,.31,1.3,1.69,.41,2.33l-4.88,3.59c-.35,.26-.55,.67-.54,1.11l.19,6.06c.03,1.1-1.2,1.75-2.09,1.12l-4.92-3.53c-.35-.25-.81-.32-1.22-.17l-5.7,2.05c-1.03,.37-2.04-.6-1.71-1.64l1.84-5.77c.13-.41,.05-.87-.22-1.21l-3.72-4.79c-.67-.87-.06-2.13,1.04-2.13l6.06-.04c.44,0,.84-.22,1.09-.58h-.01Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 65.73,
    y1: 33.99,
    x2: 74.66,
    y2: 41.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 93.73,
    y1: 54.47,
    x2: 111.51,
    y2: 47.31
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 56.01,
    cy: 21.15,
    r: 10.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 31.22,
    cy: 45.91,
    r: 10.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 52.29,
    cy: 69.09,
    r: 10.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 36.82,
    y1: 36.99,
    x2: 48.17,
    y2: 28.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 37.94,
    y1: 54.02,
    x2: 45.48,
    y2: 61.06
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M78.75,40.52l5.36-2.82c.97-.51,2.1,.31,1.92,1.39l-1.02,5.97c-.07,.43,.07,.87,.38,1.17l4.34,4.23c.78,.76,.35,2.1-.73,2.26l-6,.87c-.43,.06-.8,.33-1,.72l-2.68,5.43c-.48,.98-1.89,.98-2.37,0l-2.68-5.43c-.19-.39-.56-.66-1-.72l-6-.87c-1.08-.16-1.52-1.49-.73-2.26l4.34-4.23c.31-.3,.45-.74,.38-1.17l-1.02-5.97c-.19-1.08,.95-1.9,1.92-1.39l5.36,2.82c.39,.2,.85,.2,1.23,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M112.23,27.53l3.41-5.01c.62-.91,2-.71,2.35,.33l1.91,5.75c.14,.41,.47,.73,.89,.85l5.82,1.69c1.05,.31,1.3,1.69,.41,2.33l-4.88,3.59c-.35,.26-.55,.67-.54,1.11l.19,6.06c.03,1.1-1.2,1.75-2.09,1.12l-4.92-3.53c-.35-.25-.81-.32-1.22-.17l-5.7,2.05c-1.03,.37-2.04-.6-1.71-1.64l1.84-5.77c.13-.41,.05-.87-.22-1.21l-3.72-4.79c-.67-.87-.06-2.13,1.04-2.13l6.06-.04c.44,0,.84-.22,1.09-.58h-.01Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 61.73,
    y1: 29.99,
    x2: 70.66,
    y2: 37.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 89.73,
    y1: 50.47,
    x2: 107.51,
    y2: 43.31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSozialselbstbewusstWeb);
export default __webpack_public_path__ + "static/media/sozial&selbstbewusst_web.6a37112deeb46eb58af8232713a4ffc9.svg";
export { ForwardRef as ReactComponent };